import { render, staticRenderFns } from "./TransferNoteItemModal.vue?vue&type=template&id=4960d032&scoped=true"
import script from "./TransferNoteItemModal.vue?vue&type=script&lang=js"
export * from "./TransferNoteItemModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4960d032",
  null
  
)

export default component.exports